import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraTabBar } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PageBody, PageHero } from '../../../components/layout';
import { useLayoutStore } from '../../../lib/stores/LayoutStore';
import { CapabilitiesTab } from './CapabilitiesTab';
import { CompaniesTab } from './CompaniesTab';
import { ContactsTab } from './ContactsTab';
import { ContractVehiclesTab } from './ContractVehiclesTab';
import { GovernmentOrgsTab } from './GovernmentOrgsTab';
import { LaborCategoriesTab } from './LaborCategoriesTab';
import { PricingSheetsTab } from './PricingSheetsTab';
import { ProgramRoleTypesTab } from './ProgramRoleTypesTab';
const isTabKey = (s)=>s === 'companies' || s === 'contacts' || s === 'govorgs' || s === 'capabilities' || s === 'vehicles' || s === 'lcats' || s === 'roles' || s === 'pricing-sheets';
const TAB_PANELS = {
    companies: CompaniesTab,
    contacts: ContactsTab,
    govorgs: GovernmentOrgsTab,
    capabilities: CapabilitiesTab,
    vehicles: ContractVehiclesTab,
    lcats: LaborCategoriesTab,
    roles: ProgramRoleTypesTab,
    'pricing-sheets': PricingSheetsTab
};
export function RegistriesPage() {
    // Routed at root-level /registries, outside DeliveryLayout — so this page
    // suppresses the legacy metadata band itself and owns its header inline.
    const setShowHeader = useLayoutStore((state)=>state.setShowHeader);
    useEffect(()=>{
        setShowHeader(false);
        return ()=>setShowHeader(true);
    }, [
        setShowHeader
    ]);
    const [params, setParams] = useSearchParams();
    const active = isTabKey(params.get('tab')) ? params.get('tab') : 'companies';
    const setActive = (next)=>{
        params.set('tab', next);
        setParams(params, {
            replace: true
        });
    };
    // Only the active panel mounts — same lifecycle Radix TabsContent had, so
    // per-tab queries still fire on first visit rather than all at once.
    const ActivePanel = TAB_PANELS[active];
    return /*#__PURE__*/ _jsx(PageBody, {
        children: /*#__PURE__*/ _jsxs("div", {
            "data-testid": Testids.deliveryRegistries.page,
            children: [
                /*#__PURE__*/ _jsx(PageHero, {
                    title: "Registries",
                    subtitle: "Companies, contacts, government orgs, vehicles, labor categories, and pricing sheets"
                }),
                /*#__PURE__*/ _jsx(SpecraTabBar, {
                    label: "Registries sections",
                    value: active,
                    onValueChange: setActive,
                    options: [
                        {
                            value: 'companies',
                            label: 'Companies',
                            testId: Testids.deliveryRegistries.tabCompanies
                        },
                        {
                            value: 'contacts',
                            label: 'Contacts',
                            testId: Testids.deliveryRegistries.tabContacts
                        },
                        {
                            value: 'govorgs',
                            label: 'Government Orgs',
                            testId: Testids.deliveryRegistries.tabGovernmentOrgs
                        },
                        {
                            value: 'capabilities',
                            label: 'Capabilities',
                            testId: Testids.deliveryRegistries.tabCapabilities
                        },
                        {
                            value: 'vehicles',
                            label: 'Contract Vehicles',
                            testId: Testids.deliveryRegistries.tabVehicles
                        },
                        {
                            value: 'lcats',
                            label: 'Labor Categories',
                            testId: Testids.deliveryRegistries.tabLaborCategories
                        },
                        {
                            value: 'roles',
                            label: 'Program Roles',
                            testId: Testids.deliveryRegistries.tabRoleTypes
                        },
                        {
                            value: 'pricing-sheets',
                            label: 'Pricing Sheets',
                            testId: Testids.deliveryRegistries.tabPricingSheets
                        }
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "mt-6",
                    children: /*#__PURE__*/ _jsx(ActivePanel, {})
                })
            ]
        })
    });
}
